<template>
  <div>
    <v-overlay :value="overlay" absolute>
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>

    <v-card flat tile>
      <v-toolbar flat color="white">
        <v-toolbar-title>
          <v-icon class="mb-1">mdi-percent-outline</v-icon>
          Tarifas
        </v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-btn small color="primary" @click="abrirFormulario(null)">
          <v-icon left>mdi-plus</v-icon> Nueva tarifa
        </v-btn>
        <v-spacer></v-spacer>
        <v-col cols="2">
          <v-select
            v-model="pais"
            :items="paises"
            label="País de destino"
            hide-details
            @change="cambiarPais()"
          ></v-select>
        </v-col>
        <v-col cols="3">
          <v-select
            v-model="conceptoFiltro"
            :items="conceptosDelPais"
            item-text="NOMBRE"
            item-value="CONCEPTO_ID"
            label="Concepto"
            clearable
            hide-details
            @change="cargarLista()"
          ></v-select>
        </v-col>
        <v-col cols="2">
          <v-switch
            v-model="historicas"
            label="Ver históricas"
            hide-details
            @change="cargarLista()"
          ></v-switch>
        </v-col>
      </v-toolbar>

      <v-data-table
        :headers="headers"
        :items="lista"
        :loading="cargando"
        :items-per-page="25"
        class="elevation-1"
      >
        <template v-slot:item.ALCANCE="{ item }">
          {{ textoAlcance(item) }}
        </template>
        <template v-slot:item.PORCENTAJE="{ item }">
          {{ formatoNumero(item.PORCENTAJE, 4) }} %
        </template>
        <template v-slot:item.MINIMO="{ item }">
          {{ formatoNumero(item.MINIMO, 2) }}
        </template>
        <template v-slot:item.MAXIMO="{ item }">
          {{ formatoNumero(item.MAXIMO, 2) }}
        </template>
        <template v-slot:item.HASTA="{ item }">
          {{ item.HASTA || "Vigente" }}
        </template>
        <template v-slot:item.opcion="{ item }">
          <v-btn icon small color="green" title="Editar" @click="abrirFormulario(item)">
            <v-icon small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon small color="orange darken-2" title="Cerrar vigencia" @click="abrirCierre(item)">
            <v-icon small>mdi-calendar-end</v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>

    <v-card flat tile class="mt-4">
      <v-card-title class="subtitle-1">Simulador</v-card-title>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="5">
            <v-autocomplete
              v-model="simulacion.pro_id"
              :items="productos"
              item-text="PRO_DESC"
              item-value="PRO_ID"
              label="Producto"
            ></v-autocomplete>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field v-model="simulacion.fecha" type="date" label="Fecha de la guía"></v-text-field>
          </v-col>
          <v-col cols="12" md="2">
            <v-btn color="primary" class="mt-3" :disabled="!simulacion.pro_id || !simulacion.fecha" @click="simular()">
              Simular
            </v-btn>
          </v-col>
        </v-row>

        <div v-if="resultado">
          <v-alert v-for="(error, i) in resultado.errores" :key="i" dense outlined type="error">
            {{ error }}
          </v-alert>
          <v-simple-table dense>
            <thead>
              <tr>
                <th>Concepto</th>
                <th>Tipo</th>
                <th class="text-right">Porcentaje</th>
                <th class="text-right">Mínimo</th>
                <th class="text-right">Máximo</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="fila in resultado.aplicadas" :key="fila.CONCEPTO_ID">
                <td>{{ fila.NOMBRE }}</td>
                <td>{{ fila.TIPO }}</td>
                <td class="text-right">{{ formatoNumero(fila.PORCENTAJE, 4) }} %</td>
                <td class="text-right">{{ formatoNumero(fila.MINIMO, 2) }}</td>
                <td class="text-right">{{ formatoNumero(fila.MAXIMO, 2) }}</td>
              </tr>
              <tr class="font-weight-bold">
                <td colspan="2">Duty total de {{ resultado.producto.PRO_DESC }}</td>
                <td class="text-right">{{ formatoNumero(resultado.duty, 4) }} %</td>
                <td colspan="2"></td>
              </tr>
            </tbody>
          </v-simple-table>
        </div>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogFormulario" max-width="600px" persistent>
      <v-card>
        <v-card-title>{{ formulario.VALOR_ID ? "Editar tarifa" : "Nueva tarifa" }}</v-card-title>
        <v-card-text>
          <v-form ref="form">
            <v-select
              v-model="formulario.CONCEPTO_ID"
              :items="conceptosDelPais"
              item-text="NOMBRE"
              item-value="CONCEPTO_ID"
              label="Concepto"
              :rules="requerido"
              :disabled="!!formulario.VALOR_ID"
              @change="cambiarConcepto()"
            ></v-select>
            <v-select
              v-if="!esMpf"
              v-model="formulario.alcance"
              :items="alcances"
              label="Aplica a"
              :rules="requerido"
            ></v-select>
            <v-select
              v-if="!esMpf && formulario.alcance === 'GRUPO'"
              v-model="formulario.GRUPO_TARIFA"
              :items="gruposAsignables"
              item-text="NOMBRE"
              item-value="GRUPO_TARIFA"
              label="Grupo de tarifa"
              :rules="requerido"
            ></v-select>
            <v-autocomplete
              v-if="!esMpf && formulario.alcance === 'PRODUCTO'"
              v-model="formulario.PRO_ID"
              :items="productos"
              item-text="PRO_DESC"
              item-value="PRO_ID"
              label="Producto"
              :rules="requerido"
            ></v-autocomplete>
            <v-text-field
              v-model="formulario.PORCENTAJE"
              type="number"
              step="0.0001"
              min="0"
              max="100"
              suffix="%"
              label="Porcentaje"
              :rules="requeridoNumero"
            ></v-text-field>
            <v-row v-if="esMpf" dense>
              <v-col cols="6">
                <v-text-field v-model="formulario.MINIMO" type="number" step="0.01" min="0" label="Mínimo (USD)"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formulario.MAXIMO" type="number" step="0.01" min="0" label="Máximo (USD)"></v-text-field>
              </v-col>
            </v-row>
            <v-row dense>
              <v-col cols="6">
                <v-text-field v-model="formulario.DESDE" type="date" label="Vigente desde" :rules="requerido"></v-text-field>
              </v-col>
              <v-col cols="6">
                <v-text-field v-model="formulario.HASTA" type="date" label="Vigente hasta (opcional)"></v-text-field>
              </v-col>
            </v-row>
            <v-text-field
              v-model="formulario.REFERENCIA_LEGAL"
              label="Referencia legal"
              maxlength="255"
              :rules="requerido"
            ></v-text-field>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="dialogFormulario = false">Cancelar</v-btn>
          <v-btn small color="primary" @click="guardar()">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCierre" max-width="400px" persistent>
      <v-card>
        <v-card-title>Cerrar vigencia</v-card-title>
        <v-card-text>
          <p v-if="filaCierre">{{ filaCierre.CONCEPTO }}: {{ textoAlcance(filaCierre) }}, vigente desde {{ filaCierre.DESDE }}</p>
          <v-text-field v-model="fechaCierre" type="date" label="Vigente hasta"></v-text-field>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn small @click="dialogCierre = false">Cancelar</v-btn>
          <v-btn small color="primary" :disabled="!fechaCierre" @click="cerrar()">Cerrar vigencia</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from "vuex";

const formularioVacio = () => ({
  VALOR_ID: null,
  CONCEPTO_ID: null,
  alcance: "TODOS",
  GRUPO_TARIFA: null,
  PRO_ID: null,
  PORCENTAJE: "",
  MINIMO: "",
  MAXIMO: "",
  DESDE: "",
  HASTA: "",
  REFERENCIA_LEGAL: "",
});

export default {
  name: "TarifasComponent",
  data: () => ({
    overlay: false,
    cargando: false,
    pais: "US",
    conceptoFiltro: null,
    historicas: false,
    lista: [],
    conceptos: [],
    grupos: [],
    productos: [],
    headers: [
      { text: "Concepto", value: "CONCEPTO" },
      { text: "Aplica a", value: "ALCANCE", sortable: false },
      { text: "Porcentaje", value: "PORCENTAJE", align: "end" },
      { text: "Mínimo", value: "MINIMO", align: "end" },
      { text: "Máximo", value: "MAXIMO", align: "end" },
      { text: "Desde", value: "DESDE" },
      { text: "Hasta", value: "HASTA" },
      { text: "Referencia legal", value: "REFERENCIA_LEGAL" },
      { text: "Opciones", value: "opcion", sortable: false, width: "100px" },
    ],
    alcances: [
      { text: "Todos los productos", value: "TODOS" },
      { text: "Un grupo de tarifa", value: "GRUPO" },
      { text: "Un producto", value: "PRODUCTO" },
    ],
    requerido: [(v) => !!v || "El campo es requerido"],
    requeridoNumero: [(v) => (v !== "" && v !== null) || "El campo es requerido"],
    dialogFormulario: false,
    formulario: formularioVacio(),
    dialogCierre: false,
    filaCierre: null,
    fechaCierre: "",
    simulacion: { pro_id: null, fecha: "" },
    resultado: null,
  }),
  computed: {
    paises() {
      return [...new Set(this.conceptos.map((c) => c.PAIS_DESTINO))];
    },
    conceptosDelPais() {
      return this.conceptos.filter((c) => c.PAIS_DESTINO === this.pais);
    },
    esMpf() {
      const concepto = this.conceptos.find((c) => c.CONCEPTO_ID === this.formulario.CONCEPTO_ID);
      return !!concepto && concepto.TIPO === "MPF";
    },
    gruposAsignables() {
      // Los productos del grupo General toman la fila "Todos los productos".
      return this.grupos.filter((g) => g.GRUPO_TARIFA !== "GENERAL");
    },
  },
  methods: {
    ...mapMutations("master", ["setUrl"]),
    ...mapActions("master", ["requestApi", "alertNotification"]),

    textoAlcance(fila) {
      if (fila.PRO_ID) {
        return "Producto: " + (fila.PRO_DESC || fila.PRO_ID);
      }
      return fila.GRUPO_NOMBRE || "Todos los productos";
    },

    formatoNumero(valor, decimales) {
      if (valor === null || valor === undefined || valor === "") {
        return "";
      }
      return Number(valor).toFixed(decimales);
    },

    cargarCatalogos() {
      this.setUrl("api/tarifas-catalogos");
      this.requestApi({ method: "POST", data: {} })
        .then((res) => {
          this.conceptos = res.data.conceptos;
          this.grupos = res.data.grupos;
          this.productos = res.data.productos;
        })
        .catch(() => {});
    },

    cargarLista() {
      this.cargando = true;
      this.setUrl("api/tarifas-lista");
      this.requestApi({
        method: "POST",
        data: {
          pais: this.pais,
          historicas: this.historicas ? 1 : 0,
          concepto_id: this.conceptoFiltro,
        },
      })
        .then((res) => {
          this.lista = res.data.data;
        })
        .catch(() => {})
        .then(() => {
          this.cargando = false;
        });
    },

    cambiarPais() {
      this.conceptoFiltro = null;
      this.resultado = null;
      this.cargarLista();
    },

    cambiarConcepto() {
      if (this.esMpf) {
        this.formulario.alcance = "TODOS";
      } else {
        this.formulario.MINIMO = "";
        this.formulario.MAXIMO = "";
      }
    },

    abrirFormulario(fila) {
      this.formulario = formularioVacio();
      if (fila) {
        let alcance = "TODOS";
        if (fila.PRO_ID) {
          alcance = "PRODUCTO";
        } else if (fila.GRUPO_TARIFA) {
          alcance = "GRUPO";
        }
        this.formulario = {
          VALOR_ID: fila.VALOR_ID,
          CONCEPTO_ID: fila.CONCEPTO_ID,
          alcance,
          GRUPO_TARIFA: fila.GRUPO_TARIFA,
          PRO_ID: fila.PRO_ID,
          PORCENTAJE: fila.PORCENTAJE,
          MINIMO: fila.MINIMO === null ? "" : fila.MINIMO,
          MAXIMO: fila.MAXIMO === null ? "" : fila.MAXIMO,
          DESDE: fila.DESDE,
          HASTA: fila.HASTA || "",
          REFERENCIA_LEGAL: fila.REFERENCIA_LEGAL,
        };
      }
      this.dialogFormulario = true;
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },

    guardar() {
      if (!this.$refs.form.validate()) {
        return;
      }
      const f = this.formulario;
      this.overlay = true;
      this.setUrl("api/tarifa-guardar");
      this.requestApi({
        method: "POST",
        data: {
          VALOR_ID: f.VALOR_ID,
          CONCEPTO_ID: f.CONCEPTO_ID,
          GRUPO_TARIFA: f.alcance === "GRUPO" ? f.GRUPO_TARIFA : null,
          PRO_ID: f.alcance === "PRODUCTO" ? f.PRO_ID : null,
          PORCENTAJE: f.PORCENTAJE,
          MINIMO: f.MINIMO,
          MAXIMO: f.MAXIMO,
          DESDE: f.DESDE,
          HASTA: f.HASTA,
          REFERENCIA_LEGAL: f.REFERENCIA_LEGAL,
        },
      })
        .then((res) => {
          this.dialogFormulario = false;
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
        })
        .catch(() => {})
        .then(() => {
          this.overlay = false;
        });
    },

    abrirCierre(fila) {
      this.filaCierre = fila;
      this.fechaCierre = fila.HASTA || "";
      this.dialogCierre = true;
    },

    cerrar() {
      this.overlay = true;
      this.setUrl("api/tarifa-cerrar");
      this.requestApi({
        method: "POST",
        data: { VALOR_ID: this.filaCierre.VALOR_ID, HASTA: this.fechaCierre },
      })
        .then((res) => {
          this.dialogCierre = false;
          this.alertNotification({ param: { html: res.data.msg } });
          this.cargarLista();
        })
        .catch(() => {})
        .then(() => {
          this.overlay = false;
        });
    },

    simular() {
      this.resultado = null;
      this.setUrl("api/tarifa-simular");
      this.requestApi({
        method: "POST",
        data: { pais: this.pais, pro_id: this.simulacion.pro_id, fecha: this.simulacion.fecha },
      })
        .then((res) => {
          this.resultado = res.data;
        })
        .catch(() => {});
    },
  },
  mounted() {
    this.cargarCatalogos();
    this.cargarLista();
  },
};
</script>
